module.exports = __webpack_public_path__ + "fonts/fa-brands-400.a06da7f0.woff2";